import { EventHook } from 'slate-react';
import { BlockProperties } from 'slate';

import * as utils from './formatUtils';
import { OBJECT_TYPES, BLOCK_TYPES } from './constants';
import keys from '../../../../utils/keys';

export const handleBeforeInput: EventHook = (e, editor, next) => {
	if (utils.isStartPointInBlock(editor.value)) {
		utils.formatInsertionToStartPointOfBlock(editor);
	}

	return next();
};

export const handlePaste: EventHook = (e: ClipboardEvent, editor, next) => {
	e.preventDefault();

	if (!e.clipboardData) {
		return next();
	}

	// We have to keep existing format of copied value in case it was copied from rich text editor.
	const isCopiedFromRte = e.clipboardData.getData('isCopiedFromRte') === 'true';
	if (isCopiedFromRte) {
		return next();
	}

	const onInsert = () => {
		if (!e.clipboardData) {
			return;
		}

		const pastedValue = e.clipboardData.getData('text');
		// Split pasted value by line-breaks
		const pastedValueParagraphs = pastedValue.split(/\r?\n|\r/g);

		editor.insertText(pastedValueParagraphs[0]);

		const { value: { blocks, marks } } = editor;
		const firstParagraphData = blocks.first().get('data');

		pastedValueParagraphs.slice(1).forEach((p) => {
			editor.insertBlock({
				type: BLOCK_TYPES.p,
				data: firstParagraphData,
				nodes: [{
					object: OBJECT_TYPES.text,
					text: p,
					marks,
				}],
			} as BlockProperties);
		});
	};

	if (utils.isStartPointInBlock(editor.value)) {
		utils.formatInsertionToStartPointOfBlock(editor);
	} else if (utils.isStartPointInEmptyBlock(editor.value)) {
		utils.formatInsertionToEmptyBlock(editor);
	}

	onInsert();
};

export const handleCopy: EventHook = (e: ClipboardEvent, editor, next) => {
	if (e.clipboardData) {
		e.clipboardData.setData('isCopiedFromRte', 'true');
	}
	e.preventDefault();
	return next();
};

export const handleKeyDown: EventHook = (e: KeyboardEvent, editor, next) => {
	if ((keys.isDelete(e.key) || keys.isBackSpace(e.key))
		&& utils.isStartPointInBlock(editor.value)) {
		utils.formatInsertionToStartPointOfBlock(editor);
	}

	return next();
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/eventHooks.ts